export default __webpack_public_path__ + "img/72.4cde4a5.svg";